"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _admins = require("@/api/admins");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _adminsRoles = require("@/api/admins-roles");
var _utils = require("@/utils");
var _admin = require("@/store/modules/admin");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.roleList = [];
    this.adminToken = _admin.AdminModule;
    this.changePassword = false;
    this.formData = Object.assign({}, _admins.defaultAdminData);
    this.loading = false;
    this.securityQuestionsList = [];
    this.coordinatorList = [];
    this.rules = {
      fullName: [{
        required: true,
        message: 'Full Name is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 100,
        message: 'Length should be 3 to 100',
        trigger: 'blur'
      }],
      mobileNumber: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10',
        trigger: 'blur'
      }],
      emailAddress: [{
        required: true,
        message: 'Email is required',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Please enter correct email address',
        trigger: ['blur', 'change']
      }],
      password: [{
        required: true,
        message: 'Password is required',
        trigger: 'blur'
      }, {
        min: 6,
        message: 'Password length should be greater than 6',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    this.fetchRoles();
    this.securityQuestions();
    this.fetchCoordinatorList();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _admins.defaultAdminData);
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _admins.getAdminById)(id);
      this.formData = data;
      // Just for test
      const title = this.formData.emailAddress;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchCoordinatorList() {
    try {
      this.coordinatorList = await (0, _admins.getAdmins)((0, _utils.getQuery)({
        enabled: true,
        'adminsRole.name': ['Sales Manager', 'Sales Coordinator'],
        filter: {
          enabled: '$eq',
          'adminsRole.name': '$in'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async securityQuestions() {
    try {
      this.securityQuestionsList = await (0, _admins.getSecurityQuestions)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchRoles() {
    try {
      const roles = await (0, _adminsRoles.getRoles)((0, _utils.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
      this.roleList = Array.isArray(roles) ? roles.filter(role => role.name !== 'System Admin') : [];
    } catch (err) {} // eslint-disable-line  no-empty
  }
  resetPassword() {
    if (!this.changePassword) {
      this.formData.password = '';
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
    // (this.$refs.formData as Form).resetFields()
  }
  get selectedRoleName() {
    return this.formData.adminsRole && this.formData.adminsRole.name || '';
  }
  set selectedRoleName(val) {
    const selected = this.roleList.find(r => r.name === val);
    if (selected) {
      this.formData.adminsRoleId = selected.id;
      this.formData.adminsRole = {
        id: selected.id,
        name: selected.name
      };
    } else {
      if (!this.formData.adminsRole) {
        this.formData.adminsRole = {
          id: null,
          name: val
        };
      } else {
        this.formData.adminsRole.name = val;
      }
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        if (!this.changePassword) {
          delete this.formData.password;
        }
        if (this.formData.adminsRole && this.formData.adminsRoleId) {
          this.formData.adminsRole.id = this.formData.adminsRoleId;
        }
        await (0, _admins.updateAdmin)(this.formData.id, this.formData);
      } else {
        delete this.formData.adminsRole;
        await (0, _admins.register)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Admin saved successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push('/admins/list');
    } catch (err) {
      this.loading = false;
    }
  }
  canChangePassword() {
    // check if not edit
    if (!this.isEdit) {
      return false;
    }
    // check if super admin
    if (this.adminToken.roles && this.adminToken.roles.includes('Super Admin')) {
      return true;
    }
    // don't allow to change password otherwise
    return false;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'AdminDetail',
  components: {}
})], default_1);
var _default = exports.default = default_1;